import React from "react";
import { gql, useQuery } from "@apollo/client";
import NextMatchCard from "./NexMatchCard";

export const NEXT_MATCH = gql`
  query NextMatch($teamId: ID!) {
    nextMatch(teamId: $teamId) {
      id
      date
      homeTeam {
        name
      }
      isHomeTeamLocal
      awayTeam
      location
      time
      status
      playersConfirmed {
        id
        name
        surname
      }
    }
  }
`;

interface ITeamNextMatch {
  teamId: string;
}

const TeamNextMatch = ({ teamId }: ITeamNextMatch) => {
  const { data } = useQuery(NEXT_MATCH, { variables: { teamId } });
  const nextMatch = data && data.nextMatch;

  if (!nextMatch) return null;

  return <NextMatchCard match={nextMatch} />;
};

export default TeamNextMatch;
